import { render } from "./ImageUploader.vue?vue&type=template&id=2a1ecb60&ts=true"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=2a1ecb60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__